import { useEffect, useState } from "react";
import styled from "styled-components";
import { BASIC_BROWN, BASIC_WHITE } from "../../constants/colors";
import { useAuth } from "../../hooks/useAuth";

declare global {
  interface Window {
    WOVN: {
      io: {
        getCurrentLang: () => { code: string };
        getTextTranslation: (text: string, lang: string) => string;
      };
    };
  }
}

type Props = {
  handleLanguageSelectClick: () => void;
  handleUserGuideClick: () => void;
  handleLoginClick: () => void;
  handleMyPageClick: () => void;
};

export const HeaderMenuItem: React.FC<Props> = ({
  handleLanguageSelectClick,
  handleUserGuideClick,
  handleLoginClick,
  handleMyPageClick,
}) => {
  const { isLoggedIn } = useAuth();

  const [currentLang, setCurrentLang] = useState<string>("ja");

  useEffect(() => {
    const handleLanguageChange = () => {
      const langCode = window.WOVN?.io?.getCurrentLang?.()?.code;

      if (langCode && langCode !== currentLang) {
        setCurrentLang(langCode);
      }
    };
    window.addEventListener("wovnLangChanged", handleLanguageChange);

    return () => {
      window.removeEventListener("wovnLangChanged", handleLanguageChange);
    };
  }, [currentLang]);

  return (
    <>
      <HeaderLanguageButton onClick={handleLanguageSelectClick}>
        {currentLang === "ja" ? "言語設定 LANGUAGE" : "言語設定"}
      </HeaderLanguageButton>
      <HeaderMenuItemButton onClick={handleUserGuideClick}>
        ご利用
        <br />
        ガイド
      </HeaderMenuItemButton>
      {isLoggedIn ? (
        <HeaderMenuItemButton onClick={handleMyPageClick}>
          マイページ
        </HeaderMenuItemButton>
      ) : (
        <HeaderMenuItemButton onClick={handleLoginClick}>
          ログイン
        </HeaderMenuItemButton>
      )}
    </>
  );
};

const HeaderMenuItemButton = styled.button`
  font-size: 10px;
  line-height: 1;
  font-weight: 600;
  color: ${BASIC_BROWN};
  text-align: center;
  background-color: ${BASIC_WHITE};
  border: none;
  padding: 0;
  margin: 0 3px;
  width: 56px;
  max-height: 32px;
  vertical-align: top;
  cursor: pointer;
`;

const HeaderLanguageButton = styled.button`
  font-size: 10px;
  line-height: 1;
  font-weight: 600;
  color: ${BASIC_BROWN};
  text-align: center;
  background-color: ${BASIC_WHITE};
  border: none;
  padding: 0;
  margin: 0 3px;
  width: 70px;
  max-height: 32px;
  vertical-align: top;
  cursor: pointer;
`;
